
// function getFocusableElements(container) {
//     return Array.from(
//       container.querySelectorAll(
//         "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
//       )
//     );
//   }
//   const trapFocusHandlers = {};

//   function pauseAllMedia() {
//     document.querySelectorAll('.js-youtube').forEach((video) => {
//       video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
//     });
//     document.querySelectorAll('.js-vimeo').forEach((video) => {
//       video.contentWindow.postMessage('{"method":"pause"}', '*');
//     });
//     document.querySelectorAll('video').forEach((video) => video.pause());
//     document.querySelectorAll('product-model').forEach((model) => {
//       if (model.modelViewerUI) model.modelViewerUI.pause();
//     });
//   }
  
//   function removeTrapFocus(elementToFocus = null) {
//     document.removeEventListener('focusin', trapFocusHandlers.focusin);
//     document.removeEventListener('focusout', trapFocusHandlers.focusout);
//     document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
//     if (elementToFocus) elementToFocus.focus();
//   }

  


// function trapFocus(container, elementToFocus = container) {
//   var elements = getFocusableElements(container);
//   var first = elements[0];
//   var last = elements[elements.length - 1];

//   removeTrapFocus();

//   trapFocusHandlers.focusin = (event) => {
//     if (event.target !== container && event.target !== last && event.target !== first) return;

//     document.addEventListener('keydown', trapFocusHandlers.keydown);
//   };

//   trapFocusHandlers.focusout = function () {
//     document.removeEventListener('keydown', trapFocusHandlers.keydown);
//   };

//   trapFocusHandlers.keydown = function (event) {
//     if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
//     // On the last focusable element and tab forward, focus the first element.
//     if (event.target === last && !event.shiftKey) {
//       event.preventDefault();
//       first.focus();
//     }

//     //  On the first focusable element and tab backward, focus the last element.
//     if ((event.target === container || event.target === first) && event.shiftKey) {
//       event.preventDefault();
//       last.focus();
//     }
//   };

//   document.addEventListener('focusout', trapFocusHandlers.focusout);
//   document.addEventListener('focusin', trapFocusHandlers.focusin);

//   elementToFocus.focus();

//   if (
//     elementToFocus.tagName === 'INPUT' &&
//     ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
//     elementToFocus.value
//   ) {
//     elementToFocus.setSelectionRange(0, elementToFocus.value.length);
//   }
// }
// class ModalDialog extends HTMLElement {
//     constructor() {
//       super();
//       this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
//       this.addEventListener('keyup', (event) => {
//         if (event.code.toUpperCase() === 'ESCAPE') this.hide();
//       });
//       if (this.classList.contains('media-modal')) {
//         this.addEventListener('pointerup', (event) => {
//           if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
//         });
//       } else {
//         this.addEventListener('click', (event) => {
//           if (event.target === this) this.hide();
//         });
//       }
//     }
  
//     connectedCallback() {
//       if (this.moved) return;
//       this.moved = true;
//       document.body.appendChild(this);
//     }
  
//     show(opener) {
//       this.openedBy = opener;
//       const popup = this.querySelector('.template-popup');
//       //document.body.classList.add('overflow-hidden');
//       this.setAttribute('open', '');
//       if (popup) popup.loadContent();
//       trapFocus(this, this.querySelector('[role="dialog"]'));
//       window.pauseAllMedia();
//     }
  
//     hide() {
//       //document.body.classList.remove('overflow-hidden');
//       document.body.dispatchEvent(new CustomEvent('modalClosed'));
//       this.removeAttribute('open');
//       removeTrapFocus(this.openedBy);
//       window.pauseAllMedia();
//     }
//   }
//   customElements.define('modal-dialog', ModalDialog);
  
//   class ModalOpener extends HTMLElement {
//     constructor() {
//       super();
//       console.log("ModalOpener Constructor");
//       const button = this.querySelector('div[role=button]');
  
//       if (!button) return;
//       button.addEventListener('click', () => {
//         const modal = document.querySelector(this.getAttribute('data-modal'));
//         if (modal) modal.show(button);
//       });
//     }
//   }
//   customElements.define('modal-opener', ModalOpener);


  if (!customElements.get('popup-add-modal')) {
    customElements.define(
      'popup-add-modal',
      class PopupAddModal extends ModalDialog {
        constructor() {
          super();
          this.modalContent = this.querySelector('[id^="PopupAddInfo-"]');
        }
  
        hide(preventFocus = false) {
          const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartNotification) cartNotification.setActiveElement(this.openedBy);
  
          if (preventFocus) this.openedBy = null;
          super.hide();
        }
  
        show(opener) {
          opener.setAttribute('aria-disabled', true);
          opener.classList.add('loading');
    

              super.show(opener);
           
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
          
          
        }
  

      }
    );
  }
  